import React from 'react';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

const QuantityPad = ({
    value = '1',
    onAppend = () => { },
    onBackspace = () => { },
    onClear = () => { },
    onClose = () => { }
}) => {
    return (
        <div className='quantityPadOverlay' onClick={onClose}>
            <Paper
                className='quantityPadModal'
                onClick={(e) => e.stopPropagation()}
            >
                <div className='quantityPadModalHeader'>
                    <div className='quantityPadModalTitle'>Miktar</div>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className='quantityPadDisplay'>
                    <span>{value}</span>
                </div>

                <div className='quantityPadButtons'>
                    <Button className='quantityPadButton' onClick={() => onAppend('1')}>1</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('2')}>2</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('3')}>3</Button>

                    <Button className='quantityPadButton' onClick={() => onAppend('4')}>4</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('5')}>5</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('6')}>6</Button>

                    <Button className='quantityPadButton' onClick={() => onAppend('7')}>7</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('8')}>8</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('9')}>9</Button>

                    <Button className='quantityPadButton' onClick={() => onAppend('.')}>.</Button>
                    <Button className='quantityPadButton' onClick={() => onAppend('0')}>0</Button>
                    <Button className='quantityPadButton' onClick={onBackspace}>⌫</Button>
                </div>

                <div className='quantityPadActions'>
                    <Button
                        className='quantityPadActionButton'
                        secondary={true}
                        onClick={onClear}>
                        Temizle
                    </Button>

                    <Button
                        className='quantityPadActionButton'
                        primary={true}
                        onClick={onClose}>
                        Tamam
                    </Button>
                </div>
            </Paper>
        </div>
    );
};

export default QuantityPad;


// WEBPACK FOOTER //
// ./app/components/QuantityPad.jsx